/**
 * Checks if a given JSON string is valid.
 *
 * @param {string} jsonString - The JSON string to validate.
 * @returns {boolean} True if the JSON is valid, false otherwise.
 */
export const isValidJSONObject = (jsonString) => {
  try {
    // Attempt to parse the provided JSON string.
    JSON.parse(jsonString);
    
    // If parsing succeeds, the JSON is valid.
    return true;
  } catch (e) {
    // If an error is thrown during parsing, the JSON is not valid.
    return false;
  }
}
